import type { WebSocketMessage } from './websocket'

export default function redactEvent(event: WebSocketMessage) {
  if (event._class === 'NotificationData' && event.type === 'activity-update') {
    return {
      ...event,
      activity: {
        ...event.activity,
        body:
          event.activity.body != null
            ? `<redacted|length:${event.activity.body.length}>`
            : undefined,
      },
    }
  }

  return event
}
